import * as React from "react";
import { forwardRef } from "react";
const CarLanesIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("use", {
  href: "#a"
}), /*#__PURE__*/React.createElement("use", {
  x: 17.05,
  href: "#a"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.798 3.136a3.75 3.75 0 0 1 3.75 3.75v3.599l.568.297a.75.75 0 0 1-.568 1.374v7.955a2.25 2.25 0 0 1-2.25 2.25H8.702a2.25 2.25 0 0 1-2.25-2.25v-7.956a.747.747 0 0 1-.847-.335.75.75 0 0 1 .262-1.028l.585-.322V6.886a3.75 3.75 0 0 1 3.75-3.75h3.596zm2.25 14.704c-1.235.493-2.633.75-4.019.771-1.394.02-2.814-.199-4.077-.691v2.191a.75.75 0 0 0 .75.75h6.596a.75.75 0 0 0 .75-.75V17.84zm0-6.38c-2.562-1.002-5.535-1.06-8.096-.03v4.854c1.16.569 2.594.848 4.056.827s2.89-.343 4.04-.913V11.46zm-5.846-6.824a2.25 2.25 0 0 0-2.25 2.25V9.83c2.614-.896 5.515-.84 8.096.034V6.886a2.25 2.25 0 0 0-2.25-2.25h-3.596z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.45 10.085a.75.75 0 0 1 .75.75v3.8a.75.75 0 0 1-1.5 0v-3.8a.75.75 0 0 1 .75-.75z"
}), /*#__PURE__*/React.createElement("use", {
  href: "#b"
}), /*#__PURE__*/React.createElement("use", {
  x: -17.05,
  y: -8,
  href: "#b"
}), /*#__PURE__*/React.createElement("use", {
  y: -8,
  href: "#b"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M3.45 17.685a.75.75 0 0 1 .75.75v3.801a.75.75 0 1 1-1.5 0v-3.801a.75.75 0 0 1 .75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M20.5 10.085a.75.75 0 0 1 .75.75v3.8a.75.75 0 1 1-1.5 0v-3.8a.75.75 0 0 1 .75-.75z"
})));
const ForwardRef = forwardRef(CarLanesIcon);
export default ForwardRef;